import React from 'react'

const RefContext = React.createContext()

export default RefContext
